import * as idEndpoints from './id';
import { root, id } from './subtitles';

export const subtitles = {
  ...root,
  id: {
    id,
    ...idEndpoints,
  },
};
